<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->





function updateHeaderVisibility() {
  if (!document.body.classList.contains('template-index')) return;

  const isMobile = window.innerWidth <= 768;
  const threshold = isMobile ? 50 : 100;

  if (window.scrollY > threshold) {
    document.body.classList.add("show-header-search");
    document.body.classList.remove("hide-header-logo");
  } else {
    document.body.classList.remove("show-header-search");
    document.body.classList.add("hide-header-logo");
  }
}

document.addEventListener("scroll", updateHeaderVisibility);
document.addEventListener("DOMContentLoaded", updateHeaderVisibility);
window.addEventListener("resize", updateHeaderVisibility);



document.addEventListener('DOMContentLoaded', function() {
  function isMobile() {
    return window.innerWidth < 768;
  }

  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href$="#open-search"]'); 

    if (link) {
      e.preventDefault();

      if (isMobile()) {
        const mobileSearchToggle = document.querySelector('[data-search-mobile]');
        if (mobileSearchToggle) {
          mobileSearchToggle.click();
        }

        document.body.classList.add('open_search_mobile');

      } else {
        if (document.body.classList.contains('template-index')) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }

        const searchDetails = document.querySelector('.search_details.search_details--popup');
        if (searchDetails) {
          searchDetails.setAttribute('open', 'open');
        }

        const headerSection = document.querySelector('.shopify-section-group-header-group.section-header-navigation');
        if (headerSection) {
          headerSection.classList.add('sticky-search-menu-open');
        }

        document.body.classList.add('open_search_menu');
      }

      setTimeout(() => {
        let searchInput;

        if (document.body.classList.contains('template-index')) {
          searchInput = document.querySelector('.customSearchSummary .search__input');
        } else {
          searchInput = document.querySelector('#Search-In-Modal-Menu-Basic');
        }

        if (searchInput) {
          searchInput.focus();
        }
      }, 100);
    }
  });

  document.addEventListener('click', function(e) {
    const closeBtn = e.target.closest('.header-search-close, .search-modal__close-button');

    if (closeBtn) {
      const searchDetails = document.querySelector('.search_details.search_details--popup');
      if (searchDetails) {
        searchDetails.removeAttribute('open');
      }

      const headerSection = document.querySelector('.shopify-section-group-header-group.section-header-navigation');
      if (headerSection) {
        headerSection.classList.remove('sticky-search-menu-open');
      }

      document.body.classList.remove('open_search_menu');
    }
  });
});



